import React from "react";
import { Container, Header, Grid } from "semantic-ui-react";
import { setTitle, setMetaDescription } from "../../util";

class Press extends React.Component {
  componentDidMount() {
    document.title = setTitle(this.props.title);
    setMetaDescription(this.props.description);
  }
  render() {
    return (
      <section className="space support">
        <Container>
          <Header as="h1" className="display-1 text-uc" textAlign="center">
            Press
          </Header>
          <h2 className=" d-block ui itc-std-md normal text-black centered grid f-size--24 mx-auto my-0 ">
            For media inquiries, please contact{" "}
            <a
              className="space-no-wrap text-black px-0 hover-decoration"
              href="mailto:media@fibrestream.ca"
            >
              media@fibrestream.ca
            </a>{" "}
            or{" "}
            <a
              className="space-no-wrap text-black px-0 hover-decoration"
              href="tel:(647) 799-1023"
            >
              (647) 799-1023
            </a>
            .
          </h2>
          <Grid columns={4} className="support__footer stackable">
            <Grid.Column>
              <div>
                <Header size="tiny">Downloads</Header>
                <a href="/assets/media/fibrestream-assets.zip" target="_blank" className="cursor-pointer">Brand assets</a> <br />
              </div>
            </Grid.Column>
            <Grid.Column>
              <div>
                <Header size="tiny">Releases</Header>
              </div>
            </Grid.Column>
          </Grid>
        </Container>
      </section>
    );
  }
}

export default Press;



// WEBPACK FOOTER //
// ./src/components/press/Press.js